import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import {manageReportIssueModal,setScreenShot, handleShowfeedback} from "../../action/index.js";
import ReportIssue from '../Modals/ReportIssue.js';

function FeedbackWrapper() {
    const dispatch = useDispatch();
    const props = useSelector((state) => state.reducer);
    const [isShowReportTooltip, setShowReportTooltip] = useState(false);
    const [isShowDisclaimerTooltip, setShowDisclaimerTooltip] = useState(false);

    const disclaimers = [
        'Colors on screen may differ slightly from actual colors.',
        'Prices may change due to regional permits and certifications.',
        '3D building designs are representational only, not engineered drawings.',
        'Custom garage doors are special order items, incurring extra cost and lead time.',
        'Truss designs may differ by region.',
    ]
    
    const maxHeightHandler = () => {
        const parent = document.getElementsByClassName('disclaimer-container')[0]?.getBoundingClientRect();
        if(parent) {
            const topFromViewport = parent.top - 150;
            const content = document.querySelector('.disclaimer-tooltip-content');
            if(content) {
                content.style.maxHeight = `${topFromViewport}px`;
                content.style.overflowY = 'auto';
            }
        }
    }

    if(props?.params?.m_s_n == 153){
        disclaimers.push(<>The certification package is only available to the following: <br/> - 3/12 Roof Pitch (Lean-To's as well) <br/>- Buildings 12' Tall & Under<br/>- Buildings 30' Wide and Under</>)
    }
    const handleReportClick=()=>{
        setShowReportTooltip(!isShowReportTooltip)
        document.querySelector('body').classList.add('waiting-report-popup');
        captureElement()
    }
    let screenShotDiv = document.querySelector("#canvas > div > canvas")

    const captureElement = () => {

        let option = { name: 'image', format: 'png', quality: 1 }
        let base64image = screenShotDiv.toDataURL(option);
        dispatch(setScreenShot(base64image));
        document.querySelector('body').classList.remove('waiting-report-popup');

        // html2canvas(screenShotDiv, {
        //     width: document.body.scrollWidth,
        //     height: document.body.scrollHeight,
        //     scale: window.devicePixelRatio,
        // }).then(function(canvas) {
        //     console.log(canvas, "base64image--canvas")
        //     let option = { name: 'image', format: 'png', quality: 1 }
        //     let base64image = screenShotDiv.toDataURL(option);
        //     console.log(base64image, "base64image")
        //     dispatch(setScreenShot(base64image));
        //     document.querySelector('body').classList.remove('waiting-report-popup');
        // });
    }


    const disclaimerTooltipRef = useRef(null);
    const reportTooltipRef = useRef(null);

    useEffect(() => {
        if(disclaimerTooltipRef.current !== undefined && disclaimerTooltipRef.current != null && disclaimerTooltipRef.current.parentNode !== undefined){
            const parent = document.getElementsByClassName('disclaimer-container')[0].getBoundingClientRect();
            const child = disclaimerTooltipRef.current.getBoundingClientRect();
            if(window.innerWidth > 992) {
                disclaimerTooltipRef.current.style.top = (parent.y - child.height + 10)+'px';
                disclaimerTooltipRef.current.style.left = (parent.x - child.width - 2)+'px';
            }else {
                disclaimerTooltipRef.current.style.top = (parent.y - child.height - 11)+'px';
                disclaimerTooltipRef.current.style.left = '28px';
            }
            disclaimerTooltipRef.current.style.visibility = isShowDisclaimerTooltip ? 'visible' : 'hidden';
            maxHeightHandler()
        }
        if(window.innerWidth < 993) {
            var app = document.getElementsByClassName('App')[0];
            app.appendChild(disclaimerTooltipRef.current);
        }
        if(isShowDisclaimerTooltip && window.innerWidth > 993) {
            var infoBox = document.getElementsByClassName('info-box info-size');
            if(infoBox && infoBox.length > 0) {
                infoBox[0].style.display = 'none';
            }
        }
    }, [isShowDisclaimerTooltip])

    useEffect(() => {
        if(reportTooltipRef.current !== undefined && reportTooltipRef.current !== null && reportTooltipRef.current.parentNode !== undefined){
            const parent = reportTooltipRef.current.parentNode.getBoundingClientRect();
            const child = reportTooltipRef.current.getBoundingClientRect();
            reportTooltipRef.current.style.top = (parent.y - child.height + 10)+'px';
            reportTooltipRef.current.style.left = (parent.x - child.width)+'px';
            reportTooltipRef.current.style.visibility = isShowReportTooltip ? 'visible' : 'hidden';
        }
    }, [isShowReportTooltip])

    useEffect(() => {
        const handleResize = () => {
            setShowDisclaimerTooltip(false);
            setShowReportTooltip(false);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [])
    
    const handleOutsideClick = (event) => {
        if (disclaimerTooltipRef.current && !disclaimerTooltipRef.current.contains(event.target) && !disclaimerTooltipRef.current.parentNode.contains(event.target)) {
            setShowDisclaimerTooltip(false)
        }
        if (reportTooltipRef.current && !reportTooltipRef.current.contains(event.target) && !reportTooltipRef.current.parentNode.contains(event.target)) {
            setShowReportTooltip(false)
        }
    }

    const handleScroll = () => {
        setShowDisclaimerTooltip(false)
        setShowReportTooltip(false)
    };

    useEffect(() => {
        const scrollDiv = document.getElementsByClassName('scrollbar-plugin')[0];
        if (scrollDiv) {
          scrollDiv.addEventListener('scroll', handleScroll);
        }
        return () => {
          if (scrollDiv) {
            scrollDiv.removeEventListener('scroll', handleScroll);
          }
        };
    }, []);

    if(props.const_var.crmSetting.api_token != undefined && props.const_var.crmSetting.api_token == "GtkyWvtJE6mvNbtk4wEWHWZNeq9HGcudwHdcd9zledoPP4l7lXn3OFeagwGoDbtT"){
        disclaimers.push('12 gauge upgrade are on posts and truss only.', 'Interior panels only come 7ft tall, vertical orientation, and only in the color of bright white.')    
        maxHeightHandler()
    }
    return (
        <>
            <div className='feedback-wrapper'>
                <div className='feedback-item disclaimer-container' onClick={() => setShowDisclaimerTooltip(!isShowDisclaimerTooltip)}>
                    <i className='icon-info-ico'></i>
                    <span>Disclaimer</span>
                    <div ref={disclaimerTooltipRef} className='disclaimer-tooltip'>
                        <div className='disclaimer-title'>Disclaimer</div>
                        <div className='disclaimer-tooltip-content'>
                            {
                                disclaimers.map((item, index) => 
                                    <div className='discalimer-content-item'>
                                        <div className='disclaimer-bullet'></div>
                                        <div key={index} className='disclaimer-text'>{item}</div>
                                    </div>
                                )
                            }
                        </div>
                        <i className='icon-close' onClick={(e) => {e.stopPropagation(); setShowDisclaimerTooltip(!isShowDisclaimerTooltip)}}></i>
                    </div>
                </div>

                <div className='feedback-item feedback-container' onClick={(e) => dispatch(handleShowfeedback('prompt'))}>
                    <i className='icon-feedback'></i>
                    <span>Feedback</span>
                </div>
                {
                    props.const_var.loginSession == true && <div className={window.innerWidth > 992 ? 'feedback-item report-container':'feedback-item report-container d-none'} onClick={() =>{
                        // setShowReportTooltip(!isShowReportTooltip);
                        handleReportClick();
                    }}>
                        <i className='icon-report'></i>
                        <span>Report Error</span>
                        {
                            props.const_var.loginSession == true &&
                            <div ref={reportTooltipRef} className='report-error-tooltip'>
                                <div className='report-title'>
                                    Report Error
                                </div>
                                <div className='report-text'>
                                    We value your input! Please report any issues by clicking on the button below.
                                </div>
                                <a className='btn btn-primary' onClick={()=>{ dispatch(manageReportIssueModal(true));setShowReportTooltip(false)}}>Submit</a>
                                <i className='icon-cross-ico' onClick={() => {
                                    setShowReportTooltip(!isShowReportTooltip)
                                }}></i>
                            </div>
                        }
                    </div>
                }
                <ReportIssue show={props.const_var.showReportIssueModal} handleClose={()=>{dispatch(manageReportIssueModal(false))}} />
            </div>
            {/* <div className='feedback-hide-wrapper'>
                <i onClick={() => setShowFeedbackTooltip(!isShowFeedbackTooltip)} className='icon-info'></i>
                {
                    isShowFeedbackTooltip &&
                    <div className='feedback-tooltip'>
                        Disclaimer, Report Error, Feedback
                    </div>
                }
            </div> */}
        </>
    )
}

export default FeedbackWrapper